import React from 'react';
import { DialogTypes } from './Dialog.types';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';

export const Dialog: React.FC<DialogTypes & { className?: string }> = (props) => {
    const {isOpen, onClose, children, className = "", closeOnButton = false} = props;
    const [showModal, setShowModal] = React.useState(false);
    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        setShowModal(isOpen);
    }, [isOpen]);

    const handleClose = React.useCallback(() => {
        if (closeOnButton) {
            return;
        }
        setShowModal(false);
        onClose && onClose();
    }, [onClose, closeOnButton]);

    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent): void {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                handleClose();
            }
        }

        // @ts-ignore
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // @ts-ignore
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return createPortal(
        <>
            {showModal && (
                <>
                    <div className="pt-20 flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[50] outline-none focus:outline-none bg-[#272D33] max-tablet:pt-[6px]">
                        <div className="border-0 rounded-lg relative flex flex-col w-full outline-none focus:outline-none" ref={ref}>
                            {children}
                        </div>
                    </div>
                    <div
                        className="fixed inset-0 z-[40]"
                        style={{ backgroundColor: 'rgba(0, 0, 0, 0.64)' }}
                    ></div>
                </>
            )}
        </>,
        document.body);
};

export const MobileDialog: React.FC<DialogTypes & { className?: string }> = (props) => {
    const {isOpen, onClose, children, className = "", closeOnButton = false} = props;
    const [showModal, setShowModal] = React.useState(false);
    const ref = React.useRef<HTMLDivElement>(null);
    const location = useLocation();

    React.useEffect(() => {
        setShowModal(isOpen);
    }, [isOpen]);

    const handleClose = React.useCallback(() => {
        if (closeOnButton) {
            return;
        }
        setShowModal(false);
        onClose && onClose();
    }, [onClose, closeOnButton]);

    React.useEffect(() => {
        handleClose();
    }, [location]);

    return (
        <>
            {showModal && (
                <>
                    <div className="flex overflow-hidden inset-0 outline-none focus:outline-none bg-[#272D33] tablet:hidden">
                        <div className="border-0 rounded-lg flex flex-col w-full outline-none focus:outline-none" ref={ref}>
                            {children}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
